import { FC } from "react"

type DevicesBoxListProps = { 
    addedDevices: MediaDeviceInfo[]
    addNewDevice: (devices: MediaDeviceInfo) => void
    availableDevices: MediaDeviceInfo[]
    // removeDeviceFromManager: (device: MediaDeviceInfo) => void
    onRemoveMediaDevice: (mediaDevice: MediaDeviceInfo) => void
}

const DevicesBoxList: FC<DevicesBoxListProps> = (props) => {
    const { addedDevices, addNewDevice, availableDevices, onRemoveMediaDevice: onRemoveMediaDevices } = props
    
    const selectedDevice = (deviceOption: MediaDeviceInfo) => {
        const exist = addedDevices.some(eachDevice => eachDevice.deviceId === deviceOption.deviceId)
        return exist
    }

    /**
     * Check that the maximum extra video is 1
     */
    const validateVideoCounter = () => {
        const videos = addedDevices.filter(eachDevice => eachDevice.kind === "videoinput")
        if(videos.length === 1) return true
        return false
    }
    /**
     * Check that the maximum extra audios are 4
     */
    const validateAudioCounter = () => {
        const audioMedia = addedDevices.filter(eachDevice => eachDevice.kind === "audioinput")
        if(audioMedia.length === 4) return true
        return false
    }

    /**
     * Handles when a user click on the box of each item
     */
    const handleDeviceCheck = async (event: React.ChangeEvent<HTMLInputElement>) => {
        const deviceCheck = event.target.value;
        const exist = addedDevices.find(
            (device) => device.deviceId === deviceCheck
        );
        const currentDevice = availableDevices.find(
            (device) => device.deviceId === deviceCheck
        );
        if (exist) {
            onRemoveMediaDevices(exist)
        } else if (currentDevice) {
            //TODO IMPROVE NEXT VALIDIATIONS AND INTEGRATE IT TO ONE FUNCTION
            const currentVideo = await validateVideoCounter()
            const currentAudio = await validateAudioCounter()
            if(currentDevice.kind === "videoinput" && currentVideo){
                //Todo change next console for toast notification
                console.debug("error, maximum video devices")
                return
            }
            if(currentDevice.kind === "audioinput" && currentAudio){
                //Todo change next console for toast notification
                console.debug("error, maximum audio devices")
                return
            }

            addNewDevice(currentDevice)
        }
    };

    return(
        // eslint-disable-next-line react/jsx-no-useless-fragment
        <>
            {availableDevices.length > 0 && 
                availableDevices.map(eachDevice => (
                    <div 
                        className="CheckList" 
                        key={eachDevice.deviceId}>
                        <input
                            type="checkbox"
                            className="Check__Input"
                            checked={selectedDevice(eachDevice)}
                            value={eachDevice.deviceId}
                            onChange={(e) => handleDeviceCheck(e)}                 
                        />
                        <label htmlFor="MediaDevice"> {eachDevice.label} </label>
                    </div>
                ))
            }
        </>
    )
}

export default DevicesBoxList